export const getColumnWidth = (field) => {
  switch (field) {
    case "status":
      return 200;
    case "username":
      return 200;
    case "notes":
      return 200;
    case "firstname":
      return 200;
    case "checkbox":
      return 60;
    case "platform":
      return 70;
    case "followers":
      return 80;
    case "country":
      return 90;
    case "quality_score":
      return 100;
    case "reach":
      return 80;
    case "posts":
      return 80;
    default:
      if (field.includes("audience")) return 220;
      return 140;
  }
};
